import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { StartMatchModule } from '../match-tracker/start-match/start-match.module';
import { ScoreboardComponent } from './scoreboard';
import { ParticipantNameComponent } from './participant-name/participant-name.component';
import { ShareMatchComponentModule } from '../_shared/components/share-match/share-match.module';
import { CreateMatchModule } from '../matches/create-match/create-match.module';
import { TrackerBoardModule } from '../match-tracker/tracker-board/tracker-board.module';
import { TournamentTopRowComponent } from './tournament-top-row/tournament-top-row.component';
import { DownloadMatchComponent } from './download-match/download-match.component';
import { SuspendedMatchComponentModule } from '../_shared/components/suspended-match/suspended-match.module';
import { TrackerBarModule } from './tracker-bar/tracker-bar.module';
import { MatchDurationModule } from '../_shared/components/match-duration/match-duration.module';
import { SharedModule } from '../_shared/shared.module';
import { ScoreDisplayComponent } from './score-display/score-display.component';
import { PlaysightComponent } from './playsight/playsight.component';
import { QRCodeModule } from 'angularx-qrcode';
import { StopwatchModule } from '../_shared/components/stopwatch/stopwatch.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AddPointButtonComponent } from '../official-view/add-point-button/add-point-button.component';
import { BatteryIndicatorComponent } from '../_shared/components/battery-indicator/battery-indicator.component';
import { RossComponent } from './ross/ross.component';
import { AdditionalPlayerInfoComponent } from './additional-player-info/additional-player-info.component';
import { TimedTennisComponent } from './timed-tennis/timed-tennis.component';
import { SbAddPointOrGameComponent } from './sb-body/sb-add-point-or-game/sb-add-point-or-game.component';
import { SbStatusComponent } from './sb-body/sb-status/sb-status.component';
import { SbPointComponent } from './sb-body/sb-point/sb-point.component';
import { SbGameComponent } from './sb-body/sb-game/sb-game.component';
import { SbParticipantComponent } from './sb-body/sb-participant/sb-participant.component';
import { SbFooterComponent } from './sb-footer/sb-footer.component';
import { SbBodyComponent } from './sb-body/sb-body.component';
import { SbHeaderComponent } from './sb-header/sb-header.component';
import { ThemedStreamViewComponent } from './themed-stream-view/themed-stream-view.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        StartMatchModule,
        RouterModule,
        ShareMatchComponentModule,
        CreateMatchModule,
        TrackerBoardModule,
        SuspendedMatchComponentModule,
        TrackerBarModule,
        MatchDurationModule,
        SharedModule,
        QRCodeModule,
        StopwatchModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        RossComponent,
        SbBodyComponent,
        BatteryIndicatorComponent,
        SbAddPointOrGameComponent,
        SbStatusComponent,
        SbPointComponent,
        SbGameComponent,
        SbParticipantComponent,
        AddPointButtonComponent,
    ],
    declarations: [
        ScoreboardComponent,
        ParticipantNameComponent,
        TournamentTopRowComponent,
        DownloadMatchComponent,
        ScoreDisplayComponent,
        PlaysightComponent,
        ThemedStreamViewComponent,
        SbHeaderComponent,
        SbFooterComponent,
        TimedTennisComponent,
        AdditionalPlayerInfoComponent,
    ],
    exports: [
        ScoreboardComponent
    ]
})
export class ScoreboardModule { }
